import store from '../store/store';
import { isBulkActionRunning, isBulkActionUninitialized } from 'owa-bulk-action-store';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import ReadWriteRecipientWellViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientWellViewState';

export default function canRunCurrentEditRule(): boolean {
    // Early exit if a bulk action is already running in inbox
    if (
        isBulkActionRunning(folderNameToId('inbox')) ||
        isBulkActionUninitialized(folderNameToId('inbox'))
    ) {
        return false;
    }

    // Only 'from' is currently supported, so only 1 conditional clause is allowed
    if (store.inboxRulesEditState.conditionalClauseIds.length > 1) {
        return false;
    }

    const conditionalClause = store.inboxRulesEditState.clauseMap.get(
        store.inboxRulesEditState.conditionalClauseIds[0]
    );

    // must be 'from' type
    if (conditionalClause.clauseType != 'from') {
        return false;
    }

    const recipientWellState = conditionalClause.clauseValue as ReadWriteRecipientWellViewState;

    // make sure at least one persona
    if (recipientWellState.recipients.length == 0) {
        return false;
    }

    // DLs not supported
    for (let recipient of recipientWellState.recipients) {
        const mailbox = recipient.persona.EmailAddress;
        if (
            mailbox.MailboxType == 'PrivateDL' ||
            mailbox.MailboxType == 'PublicDL' ||
            mailbox.MailboxType == 'GroupMailbox'
        ) {
            return false;
        }
    }

    // Action must be a 'move to folder' type
    if (
        store.inboxRulesEditState.actionClauseIds.length > 1 ||
        store.inboxRulesEditState.exceptionClauseIds.length > 0
    ) {
        return false;
    }

    const actionClause = store.inboxRulesEditState.clauseMap.get(
        store.inboxRulesEditState.actionClauseIds[0]
    );
    const folderId = actionClause.clauseValue as string;

    // make sure user has selected a folder
    if (
        (actionClause.clauseType == 'moveTo' && folderId) ||
        actionClause.clauseType == 'delete' ||
        actionClause.clauseType == 'junk'
    ) {
        return true;
    }

    return false;
}
